module.exports = __webpack_public_path__ + "f97c82b76dff9f5b3ab8d4f17b8bdd18.svg";